module.exports = __webpack_public_path__ + "static/media/signup-img.e6dc1c99.jpg";